import { render, staticRenderFns } from "./ProductUserCard.vue?vue&type=template&id=31f52139"
import script from "./ProductUserCard.vue?vue&type=script&lang=js"
export * from "./ProductUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports